const PRESET_PREFIX = "preset";
const AVATAR_PRESET_COLORS = [
  "presetBlueGray",
  "presetCosmicBlue",
  "presetCrowdFlower",
  "presetCyan",
  "presetGray",
  "presetGreen",
  "presetOrange",
  "presetPurple",
  "presetPurpleBlue",
  "presetYellow"
];
const PRESET_COLORS = [
  "blueGray",
  "cosmicBlue",
  "crowdFlower",
  "cyan",
  "gray",
  "green",
  "orange",
  "purple",
  "purpleBlue",
  "yellow"
];
const AVATAR_PRESET_COLOR_RECORD = {
  default: {
    yellow: "#FAD052",
    orange: "#EE906F",
    gray: "#A6ACB8",
    purpleBlue: "#A39EF0",
    purple: "#C18FE3",
    cyan: "#42D1CF",
    cosmicBlue: "#A5B3DF",
    crowdFlower: "#C3C95E",
    green: "#59CD65",
    blueGray: "#8BACB8"
  },
  weak: {
    yellow: "#FAF2E1",
    orange: "#FAEBE6",
    gray: "#E6EBF5",
    purpleBlue: "#ECEBFC",
    purple: "#F8EEFF",
    cyan: "#E5F7F5",
    cosmicBlue: "#ECF0FB",
    crowdFlower: "#F0F2CE",
    green: "#E0EFDF",
    blueGray: "#E4EEF1"
  }
};

export { AVATAR_PRESET_COLORS, AVATAR_PRESET_COLOR_RECORD, PRESET_COLORS, PRESET_PREFIX };
//# sourceMappingURL=color.mjs.map
